// extracted by mini-css-extract-plugin
export default {"root":"jsD2e","loginMethods":"Q25py","otherProviders":"FQsHd","separator":"zcOou","separatorLine":"Pn5Ti","separatorText":"jwZ3W","wrapperOtherMethods":"gq5Lt"};